import { render, staticRenderFns } from "./introduceList.vue?vue&type=template&id=797b1b85&scoped=true"
import script from "./introduceList.vue?vue&type=script&lang=js"
export * from "./introduceList.vue?vue&type=script&lang=js"
import style0 from "./introduceList.vue?vue&type=style&index=0&id=797b1b85&prod&scoped=true&lang=css"
import style1 from "./introduceList.vue?vue&type=style&index=1&id=797b1b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797b1b85",
  null
  
)

export default component.exports